import React, { memo } from 'react';
import { TableViewComponentProps } from './types';
import TableViewComponentVirtual from './TableViewComponent.Virtual';
import TableViewComponentRegular from './TableViewComponent.Regular';

const TableViewComponent = (props: TableViewComponentProps) => {
  const { isVirtualTable } = props;

  if (isVirtualTable) {
    return <TableViewComponentVirtual {...props} />;
  }

  return <TableViewComponentRegular {...props} />;
};

export default memo(TableViewComponent);
